// =============================================================================
// src/features/explore/index.ts — Barrel da feature "Explorar".
//
// Markup da rota (unified.html 1358-1425) + comportamento TS portado de
//   assets/explore.js: ExploreRoute (open/close/init), ExploreMap (Leaflet do AM),
//   ExploreUI (chips/painel/card/legenda) e init() (porte do boot legado).
//   main.ts importa { buildExplorePageMarkup } para o markup e { init } para o
//   comportamento (substitui o <script> legado explore.js).
// =============================================================================

export { ExploreRoute, ExploreMap, init } from './explore-route';
export { ExploreUI } from './explore-ui';

/** Markup verbatim (paridade total com unified.html). */
const MARKUP = `<section class="u-explore-page" id="u-explore-page" aria-label="Explorar — mapa de Manaus" aria-hidden="true">
  <div id="exploreMap"></div>

  <!-- Barra de filtros: busca + chips (ano · partido · zona · tema) -->
  <div class="exp-topbar">
    <div class="exp-search">
      <i class="ti ti-search"></i>
      <input id="expSearch" type="search" readonly placeholder="Buscar município, zona, candidato…" aria-label="Buscar no mapa" autocomplete="off">
    </div>
    <div class="exp-chips" role="toolbar" aria-label="Filtros políticos">
      <div class="exp-chip-wrap">
        <button type="button" class="exp-chip" id="expChipAno" aria-haspopup="true" aria-expanded="false">
          <i class="ti ti-calendar-event"></i><span class="exp-chip-val">2024</span><i class="ti ti-chevron-down exp-chip-caret"></i>
        </button>
        <div class="exp-menu" id="expMenuAno" role="menu" hidden></div>
      </div>
      <!-- Cargo (so no modo Eleicoes 2026 — TSE oficial, 2026-10-13) -->
      <div class="exp-chip-wrap" id="expCargoWrap" hidden>
        <button type="button" class="exp-chip" id="expChipCargo" aria-haspopup="true" aria-expanded="false">
          <i class="ti ti-building-bank"></i><span class="exp-chip-val">Cargo</span><i class="ti ti-chevron-down exp-chip-caret"></i>
        </button>
        <div class="exp-menu" id="expMenuCargo" role="menu" hidden></div>
      </div>
      <div class="exp-chip-wrap">
        <button type="button" class="exp-chip" id="expChipPartido" aria-haspopup="true" aria-expanded="false">
          <i class="ti ti-flag-3"></i><span class="exp-chip-val">Partido</span><i class="ti ti-chevron-down exp-chip-caret"></i>
        </button>
        <div class="exp-menu" id="expMenuPartido" role="menu" hidden></div>
      </div>
      <!-- Candidato (filtro do overlay de votos · estilo Datapedia) -->
      <div class="exp-chip-wrap">
        <button type="button" class="exp-chip" id="expChipCandidato" aria-haspopup="true" aria-expanded="false">
          <i class="ti ti-user-star"></i><span class="exp-chip-val">Candidato</span><i class="ti ti-chevron-down exp-chip-caret"></i>
        </button>
        <div class="exp-menu exp-menu--candidato" id="expMenuCandidato" role="menu" hidden></div>
      </div>
      <div class="exp-chip-wrap">
        <button type="button" class="exp-chip" id="expChipRegiao" aria-haspopup="true" aria-expanded="false">
          <i class="ti ti-map-2"></i><span class="exp-chip-val">Região</span><i class="ti ti-chevron-down exp-chip-caret"></i>
        </button>
        <div class="exp-menu" id="expMenuRegiao" role="menu" hidden></div>
      </div>
      <div class="exp-chip-wrap">
        <button type="button" class="exp-chip" id="expChipTema" aria-haspopup="true" aria-expanded="false">
          <i class="ti ti-chart-bar"></i><span class="exp-chip-val">Tema</span><i class="ti ti-chevron-down exp-chip-caret"></i>
        </button>
        <div class="exp-menu" id="expMenuTema" role="menu" hidden></div>
      </div>
      <!-- Recortes municipais (decisao de produto 2026-05-31) -->
      <div class="exp-chip-wrap">
        <button type="button" class="exp-chip" id="expChipMicro" aria-haspopup="true" aria-expanded="false">
          <i class="ti ti-map-pin"></i><span class="exp-chip-val">Microrregião</span><i class="ti ti-chevron-down exp-chip-caret"></i>
        </button>
        <div class="exp-menu" id="expMenuMicro" role="menu" hidden></div>
      </div>
      <div class="exp-chip-wrap">
        <button type="button" class="exp-chip" id="expChipEleitorado" aria-haspopup="true" aria-expanded="false">
          <i class="ti ti-users"></i><span class="exp-chip-val">Eleitorado</span><i class="ti ti-chevron-down exp-chip-caret"></i>
        </button>
        <div class="exp-menu" id="expMenuEleitorado" role="menu" hidden></div>
      </div>
      <div class="exp-chip-wrap">
        <button type="button" class="exp-chip" id="expChipSegundo" aria-haspopup="true" aria-expanded="false">
          <i class="ti ti-medal-2"></i><span class="exp-chip-val">2º colocado</span><i class="ti ti-chevron-down exp-chip-caret"></i>
        </button>
        <div class="exp-menu" id="expMenuSegundo" role="menu" hidden></div>
      </div>
    </div>
  </div>

  <!-- Painel de Camadas (estilo Google Maps) -->
  <div class="exp-layers">
    <button type="button" class="exp-layers-btn" id="expLayersBtn" aria-expanded="false" aria-controls="expLayersPanel">
      <i class="ti ti-stack-2"></i><span>Camadas</span>
    </button>
    <div class="exp-layers-panel" id="expLayersPanel" hidden>
      <!-- Painel reagrupado (decisao de produto 2026-05-31): Resultado/Território/Campanha -->
      <div class="exp-lg" role="radiogroup" aria-label="Resultado eleitoral">
        <div class="exp-lg-title">Resultado eleitoral</div>
        <div id="expResultadoOptions"></div>
      </div>
      <div class="exp-lg" role="radiogroup" aria-label="Perfil do território">
        <div class="exp-lg-title">Perfil do território</div>
        <div id="expTerritorioOptions"></div>
      </div>
      <div class="exp-lg" role="radiogroup" aria-label="Campanha">
        <div class="exp-lg-title">Campanha</div>
        <div id="expCampanhaOptions"></div>
      </div>
      <!-- Índices estratégicos derivados (heurística) — decisao de produto 2026-06-01 -->
      <div class="exp-lg" role="radiogroup" aria-label="Estratégico">
        <div class="exp-lg-title">Estratégico</div>
        <div id="expEstrategicoOptions"></div>
      </div>
      <!-- Limites oficiais do TSE (2026-10-13) — camada sob demanda, off por padrao -->
      <div class="exp-lg">
        <div class="exp-lg-title">Limites eleitorais</div>
        <div id="expLimitesToggles"></div>
      </div>
      <div class="exp-lg">
        <div class="exp-lg-title">Equipamentos &amp; território</div>
        <div id="expPoiToggles"></div>
      </div>
      <div class="exp-lg">
        <div class="exp-lg-title">Campanha em campo</div>
        <div id="expCampanhaToggles"></div>
      </div>
      <div class="exp-lg">
        <div class="exp-lg-title">Ações da equipe</div>
        <button type="button" class="exp-toggle" id="expAcoesToggle" role="switch" aria-checked="false">
          <span class="exp-toggle-ic" style="--mc:#185FA5"><i class="ti ti-flag"></i></span>
          <span class="exp-toggle-label">Agenda em campo</span>
          <span class="exp-switch"></span>
        </button>
      </div>
    </div>
  </div>

  <!-- Legenda (reflete a camada/colorização ativa) -->
  <div class="exp-legend" id="expLegend" aria-live="polite" hidden></div>

  <!-- Seletor "Tipo de Visualização" (overlay de votos · estilo Datapedia, bottom-center).
       Preenchido por ExploreUI.buildVoteVizControl a partir de VOTE_VIZ_MODES. -->
  <div class="exp-viz" id="expVizControl" role="group" aria-label="Tipo de visualização de votos"></div>

  <!-- Card da zona (drill-in para o mapa detalhado) -->
  <div class="exp-card" id="expCard" hidden></div>
</section>`;

/** Devolve a string HTML literal deste bloco. */
export function buildExplorePageMarkup(): string {
  return MARKUP;
}
